import { render, staticRenderFns } from "./AddBankAccount.vue?vue&type=template&id=77ebf398&lang=html"
import script from "./AddBankAccount.vue?vue&type=script&lang=js"
export * from "./AddBankAccount.vue?vue&type=script&lang=js"
import style0 from "./AddBankAccount.vue?vue&type=style&index=0&id=77ebf398&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports